var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0157 16.0334C8.5395 16.0334 7.34277 17.2302 7.34277 18.7064V31.7799C7.34277 31.9016 7.44144 32.0003 7.56316 32.0003C7.6074 32.0003 7.65063 31.9869 7.6872 31.962L13.0864 28.2853C13.3133 28.1308 13.6117 28.1308 13.8386 28.2853L19.2375 31.9618C19.2743 31.9869 19.3177 32.0003 19.3623 32.0003C19.4847 32.0003 19.584 31.901 19.584 31.7785V18.7064C19.584 17.2302 18.3873 16.0334 16.911 16.0334H10.0157Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M12.2837 1.00549C12.9636 0.426088 13.9635 0.426087 14.6434 1.00548L16.8983 2.92708C17.1897 3.17537 17.5519 3.32541 17.9335 3.35587L20.8867 3.59153C21.7772 3.66259 22.4842 4.36968 22.5553 5.26013L22.791 8.21335C22.8214 8.59493 22.9715 8.95718 23.2198 9.24852L25.1414 11.5034C25.7208 12.1833 25.7208 13.1833 25.1414 13.8632L23.2198 16.118C22.9715 16.4094 22.8214 16.7716 22.791 17.1532L22.5553 20.1064C22.4842 20.9969 21.7772 21.704 20.8867 21.775L17.9335 22.0107C17.5519 22.0412 17.1897 22.1912 16.8983 22.4395L14.6434 24.3611C13.9635 24.9405 12.9636 24.9405 12.2837 24.3611L10.0288 22.4395C9.73745 22.1912 9.3752 22.0412 8.99362 22.0107L6.04041 21.775C5.14996 21.704 4.44286 20.9969 4.37181 20.1064L4.13614 17.1532C4.10569 16.7716 3.95564 16.4094 3.70735 16.118L1.78576 13.8632C1.20636 13.1833 1.20636 12.1833 1.78576 11.5034L3.70735 9.24852C3.95564 8.95718 4.10569 8.59493 4.13614 8.21335L4.37181 5.26013C4.44286 4.36968 5.14996 3.66259 6.04041 3.59153L8.99362 3.35587C9.3752 3.32541 9.73745 3.17537 10.0288 2.92708L12.2837 1.00549Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 13.4635,
    cy: 12.6834,
    r: 7.23008,
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M13.0099 8.92008C13.1891 8.53422 13.7377 8.53422 13.9169 8.92009L14.689 10.5828C14.7619 10.7397 14.9107 10.8478 15.0824 10.8686L16.9023 11.0892C17.3247 11.1403 17.4942 11.6621 17.1826 11.9517L15.8399 13.1999C15.7132 13.3177 15.6564 13.4926 15.6896 13.6623L16.0423 15.4614C16.1241 15.8789 15.6803 16.2013 15.3085 15.9945L13.7065 15.1032C13.5553 15.0191 13.3714 15.0191 13.2203 15.1032L11.6183 15.9945C11.2465 16.2013 10.8027 15.8789 10.8845 15.4614L11.2371 13.6623C11.2704 13.4926 11.2136 13.3177 11.0869 13.1999L9.74417 11.9517C9.43256 11.6621 9.60208 11.1403 10.0244 11.0892L11.8444 10.8686C12.0161 10.8478 12.1649 10.7397 12.2377 10.5828L13.0099 8.92008Z",
    fill: "#EFF4F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.c02cdbd89adcb2f1f124684930225dc6.svg";
export { ForwardRef as ReactComponent };